import documentReady from "./document-ready";

const setScrollableHeader = function setScrollableHeader(userOptions) {
    const header = document.querySelectorAll(".c-header--float")[0];
    const headerSubMenu = document.querySelectorAll(".c-header__submenu")[0];
    if (header == null) {
        return;
    }

    Object.assign(header.style, {
        position: "fixed",
        transform: "translateY(0)",
    });

    const headerHeight = header.clientHeight;

    const styleObject = {
        position: "fixed",
        transform: `translateY(-${headerHeight}px)`,
    };

    const logo = document.getElementById("logo-file");
    const originalLogo = logo.src;
    const primaryTextColorLogo = "/img/logo-admitad.svg";
    let currentDirection;

    const changeDirection = (direction) => {
        currentDirection = direction;

        if (direction === "down") {
            if (
                document.getElementById("menu-active") &&
                document.getElementById("menu-active").checked
            )
                return;
            Object.assign(header.style, styleObject);
            logo.src = originalLogo;
            return header.classList.remove("c-header--animated");
        }
        if (direction === "hero") {
            Object.assign(header.style, styleObject);
            header.removeAttribute("style");
            if (headerSubMenu) headerSubMenu.classList.add("c-header__submenu--blend");
            logo.src = originalLogo;
            return header.classList.remove(userOptions.classname, "c-header--animated");
        }
        if (direction === "up") {
            header.classList.add("c-header--animated");
            if (headerSubMenu) headerSubMenu.classList.remove("c-header__submenu--blend");
            Object.assign(header.style, {
                transform: "translateY(0)",
            });
            logo.src = primaryTextColorLogo;
            return header.classList.add(userOptions.classname);
        }
    };

    let prevScrollTop = 0;

    const pageScrolled = () => {
        if (pageYOffset < 0) {
            return;
        }

        let direction;

        // @TODO: Make sure the header hides more elegantly when it enters hero area
        if (pageYOffset < 800) {
            direction = "hero";
        } else if (window.pageYOffset > prevScrollTop) {
            direction = "down";
        } else {
            direction = "up";
        }

        if (direction !== currentDirection) {
            changeDirection(direction);
        }

        prevScrollTop = pageYOffset;
    };

    document.addEventListener("scroll", pageScrolled, false);
};

documentReady(() =>
    setScrollableHeader({
        topOffset: 0,
        classname: "c-header--scrolled-up",
    }),
);
